import { asynchttp } from '../../../httpsnippet-lite/targets/java/asynchttp/client.js';
import { convertWithHttpSnippetLite } from '../../../utils/convertWithHttpSnippetLite.js';
/**
 * java/asynchttp
 */
export const javaAsynchttp = {
    target: 'java',
    client: 'asynchttp',
    title: 'AsyncHttp',
    generate(request) {
        // TODO: Write an own converter
        return convertWithHttpSnippetLite(asynchttp, request);
    },
};
